<div class="countries-container">
  @if ($loading | async) {
    <div class="shimmer-wrapper" style="padding: 16px;">
      <div class="section">
        <app-shimmer-loader height="24px" width="120px" borderRadius="4px" style="margin-bottom: 8px; display: block;"></app-shimmer-loader>
        <div class="accordion-container">
          @for (i of [1,2,3,4,5]; track i) {
            <div class="group-shimmer" style="margin-bottom: 8px;">
              <app-shimmer-loader height="24px" width="100%" borderRadius="4px" style="margin-bottom: 2px; display: block;"></app-shimmer-loader>
              <div class="group-content" style="padding-top: 4px;">
                @for (j of [1,2,3]; track j) {
                  <app-shimmer-loader height="36px" width="100%" borderRadius="4px" style="margin-bottom: 2px; display: block;"></app-shimmer-loader>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  } @else {
    <div class="section">
      <div class="section-title">{{ "All Countries" | translate }}</div>
      <div class="accordion-container">
        @for (group of allCountries; track group.letter) {
          <details class="accordion-panel" open>
            <summary class="panel-header">
              <span class="panel-title">{{ group.letter }}</span>
              <span class="indicator"></span>
            </summary>
            <div class="group-content">
              @for (country of group.countries; track country.code) {
                <details class="accordion-panel country-panel">
                  <summary class="panel-header" (click)="toggleCountry(country, $event)">
                    <span class="panel-title">{{ country.name }}</span>
                    <span class="indicator"></span>
                  </summary>
                  <div class="league-list">
                    @if (loadingLeagues[country.code]) {
                      <div class="shimmer-section" style="padding: 8px 32px;">
                        @for (i of [1,2,3]; track i) {
                          <app-shimmer-loader height="24px" width="100%" borderRadius="4px" style="margin-bottom: 4px; display: block;"></app-shimmer-loader>
                        }
                      </div>
                    } @else {
                      @for (league of countryLeagues[country.code]; track league.id) {
                        <a [routerLink]="['/app/main', { outlets: { content: [currentSport, 'league', league.id, league.name] } }]"
                           class="league-item">
                          {{ league.name }}
                        </a>
                      } @empty {
                        <div class="no-data">{{ "No leagues found" | translate }}</div>
                      }
                    }
                  </div>
                </details>
              }
            </div>
          </details>
        }
      </div>
    </div>
  }
</div>
